import { api } from 'utils/hooks/useApi';

export const splitStudy = (data: any) => api().post(`/portal-api/study/split`, data);

export const createRequestForSplit = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/createForSplit`, values);

export const editRequestForSplit = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/editForSplit`, values);
